import { Icon } from '@iconify/react'
import Button from '../common/Button'

const DashboardErrorBanner = ({ errors }) => {
  const errorMessage =
    errors.overviewError?.message ||
    errors.activityError?.message ||
    errors.complianceError?.message ||
    errors.issuesError?.message ||
    'Please refresh the page'

  return (
    <div className="mb-6 p-4 bg-danger/10 border border-danger/20 rounded-lg flex items-center gap-3">
      <Icon icon="mdi:alert-circle" className="text-danger text-xl flex-shrink-0" />
      <div className="flex-1">
        <p className="text-sm text-danger font-semibold">Error loading dashboard data</p>
        <p className="text-xs text-text-secondary mt-1">{errorMessage}</p>
      </div>
      <Button variant="secondary" size="sm" onClick={() => window.location.reload()}>
        Refresh
      </Button>
    </div>
  )
}

export default DashboardErrorBanner
